<era-device-os-update-status-ui [osUpdateStatus]="osUpdateStatus()"> </era-device-os-update-status-ui>